import { SessionResponseDtoFrontendUserState as State } from '@/generated/api/models';

/**
 * Single source of truth mapping `frontendUserState` to its screen route, shared by the
 * `_app` guard and each screen's self-guard so the two can't drift into a redirect loop.
 * Returns `null` for `Active` (app proceeds) and `Unauthorized` (routed upstream as login).
 */
export function routeForState(state: (typeof State)[keyof typeof State] | null): string | null {
  switch (state) {
    case null:
      return '/server-error';
    case State.deactivated:
      return '/deactivated';
    case State['onboarding-needed']:
      return '/onboarding';
    case State['new-without-tenants']:
      return '/gate';
    case State['no-available-tenants']:
      return '/no-tenants';
    case State['tenant-activation-pending']:
      return '/pending';
    case State['tenant-selection-needed']:
      return '/tenants';
    case State.active:
    case State.unauthorized:
    default:
      return null;
  }
}

export { SessionResponseDtoFrontendUserState as FrontendUserState } from '@/generated/api/models';
